import { z } from 'zod';

export const tourStepActionWireSchema = z.object({
  label: z.string(),
  behavior: z.string(),
  navigate_to: z.string().optional(),
});

export const tourStepWireSchema = z.object({
  step_index: z.number().int(),
  title: z.string(),
  body: z.string(),
  target_selector: z.string().nullable(),
  spotlight: z.boolean(),
  primary_action: tourStepActionWireSchema,
  secondary_action: tourStepActionWireSchema.optional(),
});

export const tourDefinitionWireSchema = z.object({
  steps: z.array(tourStepWireSchema),
});

export const eligibleTourWireSchema = z.object({
  slug: z.string(),
  version: z.number().int(),
  title: z.string(),
  description: z.string().nullable(),
  trigger_type: z.enum(['LOGIN_DIGEST', 'CONTEXTUAL', 'BOTH']),
  context_route: z.string().nullable(),
  priority: z.number().int(),
  definition: z.string(),
});

export type TourStepActionWire = z.infer<typeof tourStepActionWireSchema>;
export type TourStepWire = z.infer<typeof tourStepWireSchema>;
export type TourDefinitionWire = z.infer<typeof tourDefinitionWireSchema>;
export type EligibleTourWire = z.infer<typeof eligibleTourWireSchema>;
